import { useEffect, useState } from "react";
import styles from "./AddresseManager.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { ArrowBack } from "react-ionicons";
import { getCountries, updateAddress } from "services/api";

const ModifyAddresse
  = ({ onBack, data }) => {


    console.log("data", data);


    const [values, setValues] = useState(data);
    const [errors, setErrors] = useState({});

    const [Countries, setCountries] = useState([]);

    const [isCompany, setIsCompany] = useState(data.raisonSociale && data.siret ? true : false);

    const fetchCountries = async () => {
      const response = await getCountries();
      if (response.success) {
        setCountries(response.data);
      } else {
        console.error("Erreur lors de la récupération des pays :", response.errors);
      }
    };

    useEffect(() => {
      fetchCountries();
    }, []);



    const handleSubmit = async (e) => {
      e.preventDefault();
      const response = await updateAddress({
        id: data.id,
        city: values.city,
        zipCode: values.zipCode,
        address: values.address,
        firstname: values.firstname,
        lastname: values.lastname,
        phone: values.phone,
        name: values.name,
        email: values.email,
        country: values.country || (values.pays && values.pays.alpha3),
        raisonSociale: isCompany ? values.raisonSociale : "",
        siret: isCompany ? values.siret : "",
        numTva: isCompany ? values.numTva : "",
      });

      if (!response.success) {
        if (response.errors.errors) {
          setErrors(response.errors.errors);
        }
      } else {
        setErrors({});
        onBack();
      }
      console.log(response);

    };

    return (
      <div className={styles.formContainer}>
        <p className={styles.Back} onClick={onBack}>
          <ArrowBack />
          <span>
            Retour à la sélection d’adresse
          </span>
        </p>
        <div className={styles.Title}>Modifier mon adresse de facturation</div>
        <p className={styles.Description}>Modifier mon adresse de facturation</p>
        <form onSubmit={handleSubmit}>
          <ul className={styles.InputsList}>
            <li>
              <input
                type="checkbox"
                name="company"
                id="company"
                value={true}
                checked={isCompany}
                onChange={e => {
                  setIsCompany(e.target.checked)
                  setValues({ ...values, company: e.target.checked })
                }}
              />
              <label htmlFor="company">Cette adresse est pour une entreprise</label>
            </li>
            {
              isCompany && (
                <>

                  <li className={styles.rowSplit}>
                    <label htmlFor="raison-sociale">Raison sociale*
                    </label>
                    <input
                      type="text"
                      name="raison-sociale"
                      id="raison-sociale"
                      value={values.raisonSociale}
                      onChange={e => setValues({ ...values, raisonSociale: e.target.value })}
                    />
                    {errors.raisonSociale && <span className={styles.error}>{errors.raisonSociale}</span>}
                  </li>
                  <li className={styles.rowSplit}>
                    <label htmlFor="siret">Siret*
                    </label>
                    <input
                      type="text"
                      name="siret"
                      id="siret"
                      value={values.siret}
                      onChange={e => setValues({ ...values, siret: e.target.value })}
                    />
                    {errors.siret && <span className={styles.error}>{errors.siret}</span>}
                  </li>
                  <li>
                    <label htmlFor="numTva">Numéro de TVA*
                    </label>
                    <input
                      type="text"
                      name="numTva"
                      id="numTva"
                      value={values.numTva}
                      onChange={e => setValues({ ...values, numTva: e.target.value })}
                    />
                    {errors.numTva && <span className={styles.error}>{errors.numTva}</span>}
                  </li>
                </>)
            }
            <li>
              <label htmlFor="name">Nom de l'adresse*
              </label>
              <input
                defaultValue={values.name}
                type="text"
                name="name"
                id="name"
                onChange={e => setValues({ ...values, name: e.target.value })}
              />
              {errors.name && <span className={styles.error}>{errors.name}</span>}
            </li>
            <li className={styles.rowSplit}>
              <label htmlFor="firstname">Prénom*
              </label>
              <input
                defaultValue={values.firstname}
                type="text"
                name="firstname"
                id="firstname"
                onChange={e => setValues({ ...values, firstname: e.target.value })}
              />
              {errors.firstname && <span className={styles.error}>{errors.firstname}</span>}
            </li>
            <li className={styles.rowSplit}>
              <label htmlFor="lastname">Nom*
              </label>
              <input
                defaultValue={values.lastname}
                type="text"
                name="lastname"
                id="lastname"
                onChange={e => setValues({ ...values, lastname: e.target.value })}
              />
              {errors.lastname && <span className={styles.error}>{errors.lastname}</span>}
            </li>
            {/* <li>
              <label htmlFor="email">Email (identifiant)*</label>
              <input
                type="text"
                id="email"
                defaultValue={values.email}
                name="email"
                onChange={e => setValues({ ...values, email: e.target.value })}
              />
              {errors.email && <span className={styles.error}>{errors.email}</span>}
            </li> */}
            <li>
              <label htmlFor="phone">Téléphone*
              </label>
              <input
                type="text"
                defaultValue={values.phone}
                name="phone"
                id="phone"
                onChange={e => setValues({ ...values, phone: e.target.value })}
              />
              {errors.phone && <span className={styles.error}>{errors.phone}</span>}
            </li>
            <li>
              <label htmlFor="address">Adresse (numéro et voie)*</label>
              <textarea
                type="text"
                name="address"
                defaultValue={values.address}
                id="address"
                onChange={e => setValues({ ...values, address: e.target.value })}
              />
              {errors.address && <span className={styles.error}>{errors.address}</span>}
            </li>

            <li className={styles.rowSplit}>
              <label htmlFor="zipcode">Code postal*
              </label>
              <input
                type="text"
                defaultValue={values.zipCode}
                name="zipcode"
                id="zipcode"
                onChange={e => setValues({ ...values, zipCode: e.target.value })}
              />
              {errors.zipCode && <span className={styles.error}>{errors.zipCode}</span>}
            </li>
            <li className={styles.rowSplit}>
              <label htmlFor="city">Ville*
              </label>
              <input
                type="text"
                name="city"
                id="city"
                value={values.city}
                onChange={e => setValues({ ...values, city: e.target.value })}
              />
              {errors.city && <span className={styles.error}>{errors.city}</span>}
            </li>
            <li>
              <label htmlFor="country">Pays*
              </label>
              <select
                defaultValue={values.country}
                name="country"
                id="country"
                onChange={e => setValues({ ...values, country: e.target.value })}
              >
                {Countries && Countries.map(country => <option selected={(values.country && values.country === country.alpha3) || (values.pays && values.pays.alpha3 === country.alpha3)} value={country.alpha3}>{country.name}</option>)}
              </select>
              {errors.country && <span className={styles.error}>{errors.country}</span>}
            </li>



          </ul>

          <Button type="submit">Mettre à jour mes informations</Button>
        </form>
      </div>
    );
  }

export default ModifyAddresse
  ;
